import React from 'react';
import { BrowserRouter} from "react-router-dom";
import styles from "./App.module.css";
import Navbar from './components/Navbar';
import Home  from './pages/home.jsx';
import Footer from './components/Footer.jsx';
import Testimonials from './pages/testimonial.jsx';
import Courses from './pages/courses.jsx';
import Achievements from './pages/achievments.jsx';
import Contact from './pages/contact.jsx';


function AppContent() {
  return (
    <div className={styles.app}>
      <Navbar />
      <Home />
      
      <Achievements />
      <Courses />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}



function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
export default App;